<div>
  <div class="mb-5">
    <div class="container page-content" style="padding-top: 17px">
      <div class="col-sm-12">
        <!--If there are any results-->
        <el-data-list-table
          *ngIf="roomsListArray.length > 0 && !isListLoading; else noData"
          [data]="roomsListArray"
          [totalCount]="totalCount"
          [pageSize]="size"
          [showMoreButtonEnabled]="true"
          (onChangePageSize)="pageSizeChange($event)"
          (onClickShowMore)="showMore($event)"
          (onClickAction)="action($event)"
          (onElementExpand)="onExpand($event)"
        >
        </el-data-list-table>

        <!--If there are no results-->
        <ng-template #noData>
          <app-no-results-found *ngIf="!isListLoading"></app-no-results-found>
        </ng-template>

        <app-skeleton-data-list-table
          *ngIf="isListLoading"
          style="width: 100%"
        ></app-skeleton-data-list-table>
      </div>
    </div>

    <app-action-button
      [buttons]="filteredActionButtons"
      (clickAction)="onClickAction($event)"
      [disabled]="isListLoading"
    ></app-action-button>
  </div>
</div>
